import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import {
  Copy,
  Paste,
  InsertRowAbove,
  InsertRowBelow,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Corte,
  SelectSimilar,
  CompareBlack,
  Formula,
  Ruler,
} from "common/icons";
import { withStyles } from "@material-ui/core/styles";
import {
  Delete,
  Search,
  Home,
  Flip,
  Visibility,
  VisibilityOff,
  Tonality,
} from "@material-ui/icons";
import ToolBarItem from "modules/project/components/layouts/ToolBarItem";
import SearchBox from "modules/project/components/layouts/SearchBox";
import { WBSStore } from "modules/WBS/WBSStore";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { gtag } from "ga-gtag";
import { EWBSView } from "common/enums";

const styles = (theme) => ({
  container: {
    height: "33px",
    display: "flex",
    backgroundColor: "#000",
    flexFlow: "row nowrap",
    position: "relative" as any,
  },
  invert: {
    filter: "invert(0.875)",
    "& > svg": {
      color: "red !important",
    },
  },
  tooltip: {
    width: "120px",
  },
});

type IProps = {
  classes: any;
};

@observer
class TopBarCostPlan extends React.Component<IProps> {
  state = {
    openSearch: false,
    teste: "teste",
    tooglePan: false,
  };

  processing = (action) => async () => {
    ToolbarStore.isProcessing = true;
    await action();
    ToolbarStore.isProcessing = false;
  };

  /** Deletar linha da EAP */
  deletar = () => async () => {
    ToolbarStore.changeBarStatus(true);
    let selectedLineClone = WBSStore.selectedLine;
    gtag("event", "barra_ferramenta_eap_excluir", {
      barra_ferramenta_eap_excluir: 0,
    });
    let lisTasks = WBSStore.recursiveRowGet(WBSStore.selectedLine.id);
    ToolbarStore.deleteWBSRow();
    await ToolbarStore.handelActions({
      originalOperation: "deleteWBSRow",
      undoOperation: "pasteWBSRow",
      data: {
        undoFunction: {
          function: "pasteWBSRow",
          params: [],
          selectedLine: [],
          copiedLine: {
            row: WBSStore.selectedLine,
            data: lisTasks,
          },
        },
        originalFunction: { function: "deleteWBSRow", params: [] },
      },
    });
    ToolbarStore.changeBarStatus();
    WBSStore.selectedLine = {
      index: selectedLineClone.index - 1,
      data: 0,
      WBSRowsIndex: 0,
      id: "",
      dataKey: "",
    };

    const index = selectedLineClone.index;
    WBSStore.selectedLine = selectedLineClone;
    setTimeout(() => {
      WBSStore.setSelectedLine(
        index === 0 ? index + 2 : index - 1,
        undefined,
        true
      ); // Seleciona  a linha abaixo ou acima para limpar o códico
      WBSStore.setSelectedLine(index, undefined, true); // seleciona a linha correta
      ToolbarStore.updateLastSelectedLineOfUndoList();
    }, 500);
  };

  toggleSearchBox = () => {
    this.setState((prevState: any) => ({
      openSearch: !prevState.openSearch,
    }));
  };

  render() {
    const { classes } = this.props,
      borderLeft = "1px solid #595959";
    let count = Render3dStore.countModelElements();

    return (
      <div>
        {WBSStore.currentTab == EWBSView.EAP ? (
          <div className={classes.container}>
            <ToolBarItem
              Icon={Copy}
              fontSize={16}
              title={i18n.icons.copy}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled()
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_copiar", {
                  barra_ferramenta_eap_copiar: 0,
                });

                await ToolbarStore.copyWBSRow();
              })}
            />
            {/* <ToolBarItem
              Icon={Replicate}
              fontSize={16}
              title={i18n.icons.replicate}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.replicateVerify)
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_replicar", {
                  barra_ferramenta_eap_replicar: 0,
                });
                await ToolbarStore.replicateWBSRow();
              })}
            /> */}
            <ToolBarItem
              Icon={Paste}
              fontSize={16}
              title={i18n.icons.paste}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.pasteVerify)
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_colar", {
                  barra_ferramenta_eap_colar: 0,
                });
                ToolbarStore.pasteWBSRow();
                await ToolbarStore.handelActions({
                  originalOperation: "pasteWBSRow",
                  undoOperation: "deleteWBSRow",
                  data: {
                    undoFunction: {
                      function: "deleteWBSRow",
                      params: [],
                      selectedLine: [],
                    },
                    originalFunction: { function: "pasteWBSRow", params: [] },
                  },
                });
              })}
            />

            <ToolBarItem
              fontSize={21}
              Icon={InsertRowBelow}
              styles={{ borderLeft }}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled()
              }
              title={i18n.icons.insertRowBelow}
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_inserir_linha_abaixo", {
                  barra_ferramenta_eap_inserir_linha_abaixo: 0,
                });
                ToolbarStore.createBlankWBSRow("bellow");
                await ToolbarStore.handelActions({
                  originalOperation: "createBlankWBSRow",
                  undoOperation: "deleteWBSRow",
                  data: {
                    undoFunction: {
                      function: "deleteWBSRow",
                      params: [],
                      selectedLine: [],
                    },
                    originalFunction: {
                      function: "createBlankWBSRow",
                      params: ["bellow"],
                    },
                  },
                });
              })}
            />
            <ToolBarItem
              fontSize={21}
              Icon={InsertRowAbove}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled()
              }
              title={i18n.icons.insertRowAbove}
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_inserir_linha_acima", {
                  barra_ferramenta_eap_inserir_linha_acima: 0,
                });
                await ToolbarStore.createBlankWBSRow();
                await ToolbarStore.handelActions({
                  originalOperation: "createBlankWBSRow",
                  undoOperation: "deleteWBSRow",
                  data: {
                    undoFunction: {
                      function: "deleteWBSRow",
                      params: [],
                      selectedLine: [],
                    },
                    originalFunction: {
                      function: "createBlankWBSRow",
                      params: [],
                    },
                  },
                });
              })}
            />
            <ToolBarItem
              fontSize={19}
              Icon={Delete}
              title={i18n.icons.delete}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled()
              }
              action={this.deletar()}
            />
            <ToolBarItem
              Icon={ArrowLeft}
              styles={{ borderLeft }}
              title={i18n.icons.separate}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.separateVerify)
              }
              action={this.processing(async () => {
                let tempRows = WBSStore.WBSRows.slice();
                gtag("event", "barra_ferramenta_eap_separar_itens", {
                  barra_ferramenta_eap_separar_itens: 0,
                });
                ToolbarStore.changeWBSRowLevel();
                await ToolbarStore.handelActions({
                  originalOperation: "changeWBSRowLevel",
                  undoOperation: "changeWBSRowLevel",
                  data: {
                    undoFunction: {
                      function: "changeWBSRowLevel",
                      params: tempRows,
                      selectedLine: WBSStore.selectedLine,
                    },
                    originalFunction: {
                      function: "changeWBSRowLevel",
                      params: [],
                    },
                  },
                });
              })}
            />
            <ToolBarItem
              Icon={ArrowRight}
              title={i18n.icons.agroup}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.agroupVerify)
              }
              action={this.processing(async () => {
                let tempRows = WBSStore.WBSRows.slice();
                gtag("event", "barra_ferramenta_eap_agrupar_itens", {
                  barra_ferramenta_eap_agrupar_itens: 0,
                });
                ToolbarStore.changeWBSRowLevel("forward");
                await ToolbarStore.handelActions({
                  originalOperation: "changeWBSRowLevel",
                  undoOperation: "changeWBSRowLevel",
                  data: {
                    undoFunction: {
                      function: "changeWBSRowLevel",
                      params: tempRows,
                      selectedLine: WBSStore.selectedLine,
                    },
                    originalFunction: {
                      function: "changeWBSRowLevel",
                      params: ["forward"],
                    },
                  },
                });
              })}
            />
            <ToolBarItem
              Icon={ArrowUp}
              styles={{ borderLeft }}
              title={i18n.icons.moveup}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.moveupVerify)
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_mover_cima", {
                  barra_ferramenta_eap_mover_cima: 0,
                });
                ToolbarStore.moveWBSRow();
                await ToolbarStore.handelActions({
                  originalOperation: "moveWBSRow",
                  undoOperation: "moveWBSRow",
                  data: {
                    undoFunction: {
                      function: "moveWBSRow",
                      params: ["down"],
                      selectedLine: [],
                    },
                    originalFunction: { function: "moveWBSRow", params: [] },
                  },
                });
              })}
            />
            <ToolBarItem
              Icon={ArrowDown}
              title={i18n.icons.movedown}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.movedownVerify)
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_mover_baixo", {
                  barra_ferramenta_eap_mover_baixo: 0,
                });
                ToolbarStore.moveWBSRow("down");
                await ToolbarStore.handelActions({
                  originalOperation: "moveWBSRow",
                  undoOperation: "moveWBSRow",
                  data: {
                    undoFunction: {
                      function: "moveWBSRow",
                      params: [],
                      selectedLine: [],
                    },
                    originalFunction: {
                      function: "moveWBSRow",
                      params: ["down"],
                    },
                  },
                });
              })}
            />
            {/* <ToolBarItem
              Icon={Undo}
              styles={{ borderLeft }}
              title={i18n.icons.undo}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled()
                  ? ToolbarStore.isDisabled()
                  : ToolbarStore.undoList && ToolbarStore.undoList.length === 0
              }
              action={this.processing(async () => {
                gtag("event", "barra_ferramenta_eap_desfazer", {
                  barra_ferramenta_eap_desfazer: 0,
                });
                ToolbarStore.undoWBSRow();
                await ToolbarStore.handelActions({
                  originalOperation: "undoWBSRow",
                });
              })}
            /> */}
            <ToolBarItem
              Icon={Formula}
              styles={{ borderLeft, paddingTop: 3 }}
              title={i18n.icons.formula}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : ToolbarStore.isDisabled(ToolbarStore.formulaVerify)
              }
              action={() => {
                gtag("event", "barra_ferramenta_eap_formula", {
                  barra_ferramenta_eap_formula: 0,
                });
                WBSStore.editingFormula = !WBSStore.editingFormula;
              }}
            />
            <ToolBarItem
              data-testid="iconButton-ToolBarCostPlanSearch"
              Icon={Search}
              fontSize={20}
              styles={{ borderLeft }}
              disabled={
                ToolbarStore.disableBar
                  ? ToolbarStore.disableBar
                  : WBSStore.tab === 1
              }
              action={() => {
                gtag("event", "barra_ferramenta_eap_buscar", {
                  barra_ferramenta_eap_buscar: 0,
                });
                this.toggleSearchBox();
              }}
            />
            <SearchBox
              open={this.state.openSearch}
              onClose={() => this.toggleSearchBox()}
            />
          </div>
        ) : (
          <div className={classes.container}>
            <ToolBarItem
              Icon={Home}
              action={async () => {
                gtag("event", "viewer_restaurar", {
                  viewer_restaurar: 0,
                });
                await Render3dStore.resetView();
              }}
              fontSize={21}
              styles={{ borderLeft }}
              title={i18n.viewer.toolbar.restore}
              placement="bottom"
            />
            <ToolBarItem
              Icon={SelectSimilar}
              action={async () => {
                gtag("event", "viewer_selecionar_similares", {
                  viewer_selecionar_similares: 0,
                });
                Render3dStore.selectSimilarElements();
              }}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              disabled={count == 0}
              fontSize={20}
              title={i18n.viewer.toolbar.similar}
              placement="bottom"
            />
            <ToolBarItem
              Icon={Flip}
              action={() => {
                gtag("event", "viewer_isolar_selecao", {
                  viewer_isolar_selecao: 0,
                });
                Render3dStore.setIsolateItems(true);
              }}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              disabled={count == 0}
              fontSize={21}
              title={i18n.viewer.toolbar.isolate}
              placement="bottom"
            />

            <ToolBarItem
              Icon={CompareBlack}
              action={() => {
                gtag("event", "viewer_destacar_selecao", {
                  viewer_destacar_selecao: 0,
                });
                Render3dStore.setHighLightXeokit();
              }}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              disabled={count == 0}
              fontSize={21}
              title={i18n.viewer.toolbar.highlight}
              placement="bottom"
            />

            <ToolBarItem
              Icon={Visibility}
              action={() => {
                gtag("event", "viewer_tornar_visivel", {
                  viewer_tornar_visivel: 0,
                });
                Render3dStore.setVisible();
              }}
              fontSize={21}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              title={i18n.viewer.toolbar.makeVisible}
              placement="bottom"
            />
            <ToolBarItem
              Icon={VisibilityOff}
              action={() => {
                gtag("event", "viewer_tornar_invisivel", {
                  viewer_tornar_invisivel: 0,
                });
                Render3dStore.setInvisible();
              }}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              disabled={count == 0}
              fontSize={21}
              title={i18n.viewer.toolbar.makeUnvisible}
              placement="bottom"
            />
            <ToolBarItem
              Icon={Tonality}
              action={() => {
                gtag("event", "viewer_normal_esmaecer", {
                  viewer_normal_esmaecer: 0,
                });

                Render3dStore.setFade();
              }}
              fontSize={21}
              fontColor={
                count == 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : "rgba(255, 255, 255, 0.6)"
              }
              disabled={count == 0}
              title={i18n.viewer.toolbar.fade}
              placement="bottom"
            />

            <ToolBarItem
              Icon={Ruler}
              action={() => {
                gtag("event", "viewer_regua", {
                  viewer_regua: 0,
                });

                Render3dStore.distanceMeasurements();
              }}
              fontSize={20}
              fontColor={
                Render3dStore.isDistanceMeasurements
                  ? "#ABC200"
                  : "rgba(255, 255, 255, 0.6)"
              }
              title={i18n.viewer.toolbar.ruler}
              placement="bottom"
            />

            <ToolBarItem
              Icon={Corte}
              action={() => {
                gtag("event", "viewer_ferramenta_corte", {
                  viewer_ferramenta_corte: 0,
                });

                Render3dStore.sectionPlanes();
              }}
              fontSize={20}
              fontColor={
                Render3dStore.isSectionPlanes
                  ? "#ABC200"
                  : "rgba(255, 255, 255, 0.6)"
              }
              title={i18n.viewer.toolbar.cut}
              placement="bottom"
            />
            {/* <ToolBarItem
              Icon={Search}
              action={() => {
                this.toggleSearchBox();
              }}
              fontSize={20}
              styles={{ borderLeft }}
              title={i18n.viewer.toolbar.search}
              placement="bottom"
            />
            <SearchBox
              open={this.state.openSearch}
              leftOffset={45}
              onClose={() => this.toggleSearchBox()}
            /> */}
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(TopBarCostPlan);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/ToolBarCostPlan.tsx